import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { OsagoDocument } from '~/shared/api'
import { AsyncGrid, FetchRowsFn } from '~/shared/ui/AsyncGrid'
import { columns } from './columns'
import { GridRow } from './types'

type ListProps = {
  carId: UniqueId
}

export const List = ({ carId }: ListProps) => {
  const { t } = useTranslation()
  const fetchRows = useCallback<FetchRowsFn<GridRow>>(
    async (page, pageSize) => {
      const builder = OsagoDocument.limit(pageSize)
        .where('carId', carId)
        .where('isActive', 'false')
        .with('counterparty')
        .orderBy('-createdAt')

      const response = await builder.get(page)
      const data = response.getData()
      const rows = data.map((osagoDocument) => ({
        ...osagoDocument.getAttributes(),
        id: osagoDocument.getApiId() as string,
        counterpartyName: osagoDocument.getCounterparty()?.getName(),
      }))

      const httpClientResponse = response.getHttpClientResponse()
      const axiosResponse = httpClientResponse?.getUnderlying()
      const total = axiosResponse?.data?.meta?.page?.total || 0

      return {
        rows,
        total,
      }
    },
    [carId],
  )

  return (
    <AsyncGrid<GridRow>
      gridKey='osago-document-list'
      nestedGridKey={carId}
      fetchRows={fetchRows}
      columns={columns}
      memoryLocal
      smallTitle={t('archived documents')}
    />
  )
}
